export enum ECategory {
  University = 'University',
  School = 'School',
  University_Pole = 'University_Pole',
  Institute = 'Institute',
}
